import { createContext } from "react";

/** What the screen on show puts in the mobile header. */
export type MobileHeaderOptions = {
  /** Centred in the header; nothing when the screen has no name to give. */
  readonly title?: string;
  /**
   * A drill-down screen: a back arrow replaces the menu button. Pass a stable
   * function (`useCallback`), or the header is re-set on every render.
   */
  readonly onBack?: () => void;
  /**
   * The menu can't open for now: a conversation is being created, and the
   * sidebar's history entry would take the replace meant for the welcome
   * screen.
   */
  readonly isMenuDisabled?: boolean;
  /**
   * What the screen is waiting for is late: the connection banner says the
   * network is slow, so the wait does not read as a frozen screen.
   */
  readonly isConnectionSlow?: boolean;
};

/** The mobile header's content, read by the header alone. */
export const MobileHeaderOptionsContext = createContext<MobileHeaderOptions>(
  {},
);

/**
 * Sets the header's content. A context of its own, stable for the provider's
 * life: a screen that sets its title does not re-render when the title it set
 * comes back through the options.
 */
export const MobileHeaderSetterContext = createContext<
  (options: MobileHeaderOptions) => void
>(() => {});
